export class Easing {
    static EaseInOutCubic(t) {
        return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    }
    static EaseInCubic(x) {
        return x * x * x;
    }
    static EaseOutCubic(x) {
        return 1 - Math.pow(1 - x, 3);
    }
    static EaseOutSine(x) {
        return Math.sin((x * 3.1415) / 2);
    }
    static EaseInSine(x) {
        return 1 - Math.cos((x * 3.1415) / 2);
    }

}

interface AnimationOptions {
    delay?: number,
    duration: number,
    startCallback?: Function,
    updateCallback?: Function,
    completeCallback?: Function

    startTime?: number,
    endTime?: number
}

export class Animator {
    static animations = [];

    static animate(options: AnimationOptions) {
        // Default values.
        options = {
            delay: 0,
            duration: 1000,
            ...options
        }

        // Additional parameters
        options = {
            ...options,
            startTime: options.delay + Date.now(),
            endTime: options.delay + Date.now() + options.duration
        }

        // Add to animation queue.
        let animationData = {
            ...options,
            started: false,
            completed: false
        }

        // Queue animation.
        this.animations.push(animationData);

        // Return reference data.
        return animationData;
    }

    static update() {
        // Animate
        this.animations.forEach((animation) => {
            if (Date.now() < animation.startTime) return;

            if (animation.started == false) {
                animation.startCallback?.();
                animation.started = true;
            }

            if (Date.now() <= animation.endTime) {
                let t = (Date.now() - animation.startTime) / (animation.endTime - animation.startTime);
                animation.updateCallback?.(t);

            } else {
                //console.log("Animation complete.");

                animation.updateCallback?.(1);
                animation.completeCallback?.();

                animation.completed = true;
            }
        });

        // Clear expired animations.
        this.animations = this.animations.filter(animation => !animation.completed);
    }

}